import React, { useState } from 'react';
import { submitDeletionRequest } from '../services/deletionService';

interface FinalConfirmationProps {
  onConfirm: (requestId: string) => void;
  onCancel: () => void;
}

const FinalConfirmation: React.FC<FinalConfirmationProps> = ({ onConfirm, onCancel }) => {
  const [confirmationText, setConfirmationText] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const REQUIRED_TEXT = 'DELETE MY ACCOUNT';
  const isConfirmed = confirmationText === REQUIRED_TEXT;

  const handleConfirm = async () => {
    if (isConfirmed) {
      setIsLoading(true);
      try {
        const response = await submitDeletionRequest();
        onConfirm(response.requestId);
      } catch (error: any) {
        console.error('Failed to submit deletion request:', error);
        const errorMessage = error.message || 'Unknown error occurred';
        const errorCode = error.code || 'unknown';
        alert(`Failed to submit deletion request.\n\nError: ${errorMessage}\nCode: ${errorCode}\n\nPlease check the console for details.`);
        setIsLoading(false);
      }
    }
  };

  return (
    <div className="final-confirmation">
      <div className="warning-box">
        <h2>⚠️ Final Warning</h2>
        <p>This is your final opportunity to cancel</p>
        <ul>
          <li>Your data deletion request will be processed within 30 days</li>
          <li>Your account will be immediately deactivated</li>
          <li>All your XETA services will stop working</li>
        </ul>
      </div>

      <div className="confirmation-input">
        <p>
          To confirm deletion, type <strong>{REQUIRED_TEXT}</strong> below:
        </p>
        <input
          type="text"
          value={confirmationText}
          onChange={(e) => setConfirmationText(e.target.value)}
          placeholder="Type the confirmation text"
          disabled={isLoading}
        />
      </div>

      <div className="button-group">
        <button onClick={onCancel} className="cancel-button" disabled={isLoading}>
          Cancel
        </button>
        <button
          onClick={handleConfirm}
          className="confirm-deletion-button"
          disabled={!isConfirmed || isLoading}
        >
          {isLoading ? 'Processing...' : 'Confirm Deletion'}
        </button>
      </div>
    </div>
  );
};

export default FinalConfirmation;
